import { useState, useEffect, useRef } from "react";
import axios from 'axios';
import strings from './strings.json';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import invoiceimg from "./invoiceimg.json";
import md5 from 'md5';

function Damages({ lang }) {
  const [modal, setModal] = useState(false);
  const [addmodal, setAddModal] = useState(false);
  const [cars, setCars] = useState("");
  const [carId, setCarId] = useState("");
  const [carName, setCarName] = useState("");
  const [carPlate, setCarPlate] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [license, setLicense] = useState("");
  const [newLine, setNewLine] = useState(0);
  const [reason, setReason] = useState("");
  const [reason2, setReason2] = useState("");
  const [reason3, setReason3] = useState("");
  const [reason4, setReason4] = useState("");
  const [amount, setAmount] = useState(0);
  const [amount2, setAmount2] = useState(0);
  const [amount3, setAmount3] = useState(0);
  const [amount4, setAmount4] = useState(0);
  const tableRef = useRef(null)
  const [company, setCompany] = useState("");
  const [ddate, setDdate] = useState("");
  const [disableComp, setDisableComp] = useState(false);
  const companies = ['HARD ROCK RIDERS', 'BRAXTONE PLUS', 'GULF ASSIST CO'];
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dldmodal, setDldModal] = useState(false);
  const [last, setLast] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [vat, setVat] = useState(0);
  const [totalVat, setTotalVat] = useState(0);
  const today = new Date();
  const formattedDate = today.toLocaleDateString();

  const handleClick = () => {
    if (newLine < 3) {
      setNewLine(prev => prev + 1);
    }
  };

  const openModal = (cId, cName, cLicense, cMobile, cCar, cPlate, cAmount, cAmount2, cAmount3, cAmount4, cVat, cReason, cReason2, cReason3, cReason4, cCompany, cDdate) => {
    setCarId(cId);
    setName(cName);
    setLicense(cLicense);
    setMobile(cMobile);
    setCarName(cCar);
    setCarPlate(cPlate);
    setAmount(cAmount);
    setAmount2(cAmount2);
    setAmount3(cAmount3);
    setAmount4(cAmount4);
    setVat(cVat);
    setReason(cReason);
    setReason2(cReason2);
    setReason3(cReason3);
    setReason4(cReason4);
    setCompany(cCompany);
    setDdate(cDdate);
    setModal(!modal);
    const modalDiv = document.querySelector(".booking-modal__car-info");
    modalDiv.scroll(0, 0);
  }

  const handleCompany = (event) => {
    setCompany(event.target.value);
    setDisableComp(true);
  };

  let [filteredData,setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const closeModal = () => {
    setModal(!modal);
    setDisableComp(false);
    setCompany("");
    setName("");
    setDdate("");
    setCarName("");
    setCarPlate("");
    setLicense("");
    setMobile("");
    setAmount(0);
    setReason("");
    setAmount2(0);
    setReason2("");
    setAmount3(0);
    setReason3("");
    setAmount4(0);
    setReason4("");
    setNewLine(0);
    setVat(0);
  }

  const addModal = () => {
    setAddModal(!addmodal);
    const modalDiv = document.querySelector(".booking-modal__car-info");
    modalDiv.scroll(0, 0);
  }

  const [data, setData] = useState([]);

  const fetchData = async(e) => {
    try {
      const response = await axios({
        method: "get",
        url: "https://api.hardrockrental.net/getDamages.php",
        headers: { "Content-Type": "multipart/form-data" },
      });
      setFilteredData(response.data);
      setData(response.data);
      setLast(response.data[response.data.length-1].id+1);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const fetchCars = async() => {
    try {
      const response = await axios({
        method: "get",
        url: "https://api.hardrockrental.net/getCarNames.php",
        headers: { "Content-Type": "multipart/form-data" },
      });
      setCars(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  useEffect(() => {
      fetchData();
      fetchCars();
  }, []);

  const generatePdf = (gId, gName, gLicense, gMobile, gCar, gPlate, gAmount, gAmount2, gAmount3, gAmount4, gVat, gReason, gReason2, gReason3, gReason4, gCompany, gDdate) => {
      const element = document.getElementById("content1");
      html2canvas(element)
        .then(() => {
          const yearPrefix = new Date().getFullYear().toString().slice(-2);
          const invoiceNumber = "DMG"+yearPrefix+gId;
          const pdf = new jsPDF();
          pdf.addImage(invoiceimg.svg, 0, 0, 210, 300);
          pdf.setFontSize(13);
          pdf.text(invoiceNumber, 166, 81);
          pdf.text(gName, 21, 81);
          if (gLicense.length === 15) {
            pdf.text("VAT No.: "+gLicense, 21, 87);
          } else {
            pdf.text("Driving License No.: "+gLicense, 21, 87);
          }
          pdf.text("Mobile No.: "+gMobile, 21, 93);
          pdf.text("Car Type: "+gCar, 21, 99);
          pdf.text("Car Plate No.: "+gPlate, 21, 106);
          pdf.text(new Date((new Date().getTime()) + 3 * 60 * 60 * 1000).toISOString().split("T")[0], 163, 99); // Right
          pdf.text(gReason, 21, 137);
          pdf.text(gAmount+" BD", 143, 137); // Right
          
          if (gReason2 !== "") {
          pdf.text(gReason2, 21, 152);
          pdf.text(gAmount2+" BD", 143, 152); // Right
          }
          
          if (gReason3 !== "") {
          pdf.text(gReason3, 21, 166);
          pdf.text(gAmount3+" BD", 143, 166); // Right
          }

          if (gReason4 !== "") {
          pdf.text(gReason4, 21, 180);
          pdf.text(gAmount4+" BD", 143, 180); // Right
          }

          // pdf.text(totalDch+" BD", 143, 152); // Right
          pdf.text(gVat+" BD", 143, 199);
          pdf.text((gAmount+gAmount2+gAmount3+gAmount4+gVat)+" BD", 143, 221);
          setTimeout(() => {
            pdf.save(invoiceNumber + ".pdf");
          }, 1000);
        })
        .catch((error) => {
          console.error("Error generating PDF:", error);
        });
    };

  const generateCompPdf = ( invoiceNumber ) => {
      const element1 = document.getElementById("content1");
      html2canvas(element1)
        .then(() => {
          const pdf = new jsPDF();
          pdf.addImage(invoiceimg.svg, 0, 0, 210, 300);
          pdf.setFontSize(13);
          pdf.text(invoiceNumber, 166, 81);
          pdf.text(company+" W.L.L", 21, 83);
          if (company === 'GULF ASSIST CO') {
          pdf.text("Office#11 Bulding#2332 Road#2830 Block#428", 21, 90);
          pdf.text("Al Seef District P.O.Box:2790 Manama", 21, 97);
          pdf.text("Kingdom of Bahrain TRN:220000618700002", 21, 104);
          } else if (company === 'BRAXTONE PLUS') {
          pdf.text("Flat/Shop No. 21, Building 2304, Road/Street 2830", 21, 90);
          pdf.text("AL SEEF, Block 428 Bahrain", 21, 97);
          pdf.text("TAN: 220001304300002 CR NO. 86167-1", 21, 104);
          } else {
          pdf.text("Office#1775 Road#840 Block708 Salmabad", 21, 90);
          pdf.text("TAN:220019160900002 CR NO. 152036-1", 21, 97 );
          }
          pdf.text(new Date((new Date().getTime()) + 3 * 60 * 60 * 1000).toISOString().split("T")[0], 163, 98); // Right
          pdf.text("Damages ("+filteredData.length+")", 21, 137);
          pdf.text(totalPrice+" BD", 143, 137); // Right
          // pdf.text(totalDch+" BD", 143, 152); // Right
          pdf.text(totalVat+" BD", 143, 199);
          pdf.text((totalPrice+totalVat)+" BD", 143, 221);
  
          setTimeout(() => {
            pdf.save(invoiceNumber+".pdf");
            openDownloadModal();
            addInvoice();
          }, 1000);
        })
        .catch((error) => {
          console.error("Error generating Company PDF:", error);
        });
    };

  const closeAddModal = () => {
    document.getElementById("myCompany").selectedIndex = 0;
    setDisableComp(false);
    setCompany("");
    setName("");
    setDdate("");
    setCarName("");
    setCarPlate("");
    setLicense("");
    setMobile("");
    setAmount(0);
    setReason("");
    setAmount2(0);
    setReason2("");
    setAmount3(0);
    setReason3("");
    setAmount4(0);
    setReason4("");
    setNewLine(0);
    setVat(0);
    setAddModal(!addmodal);
    const modalDiv = document.querySelector(".booking-modal__car-info");
    modalDiv.scroll(0, 0);
  }

  const openDownloadModal = () => {
    document.getElementById("myCompany1").selectedIndex = 0;
    setDldModal(!dldmodal);
    setDisableComp(false);
    setCompany("");
    setStartDate("");
    setEndDate("");
    fetchData();
    const modalDiv = document.querySelector(".booking-modal__car-info");
    modalDiv.scroll(0, 0);
  }

  var bodyFormData = new FormData();

  const updateRent = async() => {
  bodyFormData.append('id', carId);
  bodyFormData.append('name', name);
  bodyFormData.append('license', license);
  bodyFormData.append('mobile', mobile);
  bodyFormData.append('car', carName);
  bodyFormData.append('plate', carPlate);
  bodyFormData.append('reason', reason);
  bodyFormData.append('amount', parseFloat(amount).toFixed(2));
  bodyFormData.append('reason2', reason2);
  bodyFormData.append('amount2', parseFloat(amount2).toFixed(2));
  bodyFormData.append('reason3', reason3);
  bodyFormData.append('amount3', parseFloat(amount3).toFixed(2));
  bodyFormData.append('reason4', reason4);
  bodyFormData.append('amount4', parseFloat(amount4).toFixed(2));
  bodyFormData.append('vat', parseFloat(vat).toFixed(2));
  bodyFormData.append('company', company);
  bodyFormData.append('ddate', ddate);
  bodyFormData.append('signature2', sessionStorage.getItem("userdata"));
  
    try {
      await axios({
        method: "post",
        url: "https://api.hardrockrental.net/updateDamages.php",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      setModal(!modal);
      document.getElementById("myCompany").selectedIndex = 0;
    setDisableComp(false);
    setCompany("");
    setName("");
    setDdate("");
    setCarName("");
    setCarPlate("");
    setLicense("");
    setMobile("");
    setAmount(0);
    setReason("");
    setAmount2(0);
    setReason2("");
    setAmount3(0);
    setReason3("");
    setAmount4(0);
    setReason4("");
    setNewLine(0);
    setVat(0);
    fetchData();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  var formData = new FormData();
  formData.append('id', last);

  const addDamage = async() => {
  formData.append('name', name);
  formData.append('license', license);
  formData.append('mobile', mobile);
  formData.append('car', carName);
  formData.append('plate', carPlate);
  formData.append('reason', reason);
  formData.append('amount', parseFloat(amount).toFixed(2));
  formData.append('reason2', reason2);
  formData.append('amount2', parseFloat(amount2).toFixed(2));
  formData.append('reason3', reason3);
  formData.append('amount3', parseFloat(amount3).toFixed(2));
  formData.append('reason4', reason4);
  formData.append('amount4', parseFloat(amount4).toFixed(2));
  formData.append('vat', parseFloat(vat).toFixed(2));
  formData.append('company', company);
  formData.append('ddate', ddate);
  formData.append('signature', sessionStorage.getItem("userdata"));
  formData.append('signature2', sessionStorage.getItem("userdata"));

    try {
      await axios({
        method: "post",
        url: "https://api.hardrockrental.net/addDamages.php",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      setAddModal(!addmodal);
      document.getElementById("myCompany").selectedIndex = 0;
    setDisableComp(false);
    setCompany("");
    setName("");
    setDdate("");
    setCarName("");
    setCarPlate("");
    setLicense("");
    setMobile("");
    setAmount(0);
    setReason("");
    setAmount2(0);
    setReason2("");
    setAmount3(0);
    setReason3("");
    setAmount4(0);
    setReason4("");
    setNewLine(0);
    setVat("");
    fetchData();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const [visibleRows, setVisibleRows] = useState(10);
  
    const handleLoadMore = () => {
      setVisibleRows((prevRows) => prevRows + 10);
    };
  
    const handleShowAll = () => {
      setVisibleRows(data.length);
    };
  
    const handleLoadLess = () => {
      setVisibleRows((prevRows) => prevRows - 10);
    };
  

  const searchSpace = (event) => {
    setSearch(event.target.value);
    if(event.target.value === "") {
      setFilteredData(data);
    } else {
      filteredData = data.filter((datas)=>{
        if((datas.car).includes(search.toUpperCase()) || (String(datas.plate)).includes(search) || (String(datas.mobile)).includes(search) || (String(datas.license)).includes(search) || (datas.reason).includes(search) || (datas.company).includes(search.toUpperCase())){
          return datas
        } else {
          return false;
        }
      });
      setFilteredData(filteredData);
    }
  }

  const FormDld = (e) => {
        setEndDate(e);
        filteredData = data.filter(form => {
          const expiry = new Date(form.ddate);
          const start = new Date(startDate);
          const end = new Date(e);
      
          return (
              (start && end && expiry >= start && expiry <= end) &&
              (company === "" || form.company.toLowerCase() === company.toLowerCase())
          );
      });
      
      setTotalPrice(filteredData.reduce((sum, form) => parseFloat(sum) + (parseFloat(form.amount) + parseFloat(form.amount2) + parseFloat(form.amount3) + parseFloat(form.amount4)), 0));
      setTotalVat(filteredData.reduce((sum, form) => parseFloat(sum) + (parseFloat(form.vat)), 0));
      setFilteredData(filteredData);
      }
      
      const getInvoice = async() => {
        try {
          const response = await axios({
            method: "post",
            url: "https://api.hardrockrental.net/getInvoice.php",
            data: {"inv": "damage"},
            headers: { "Content-Type": "multipart/form-data" },
          });
        const invoiced = (parseInt(response.data.invoiced)+1).toString().padStart(2, "0");
        const yearPrefix = new Date().getFullYear().toString().slice(-2); // Get last two digits of the current year
        const invoiceNumber = "DMG"+yearPrefix+invoiced;
        generateCompPdf(invoiceNumber);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
      
      const addInvoice = async() => {
        try {
          await axios({
            method: "post",
            url: "https://api.hardrockrental.net/addInvoice.php",
            data: {"inv": "damage"},
            headers: { "Content-Type": "multipart/form-data" },
          });
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
  
  return (
    <>
      <div className="team-container" id="content1" style={{ paddingBottom: "0px" }}>
        <p>
        {strings[lang].Vehicles1} {sessionStorage.getItem("userdata").toUpperCase()}{" "}
          <i className="fa-regular fa-face-grin-beam"></i>
          <br></br> {strings[lang].Vehicles2} <b>{data.length} {strings[lang].Panel3}</b>
        </p>
        <input placeholder={strings[lang].Vehicles5} value={search} id="search" type="text" onChange={(e)=>searchSpace(e)}/>
        <button type="submit" style={{ borderRadius: "50px", boxShadow: "none"}} onClick={() => addModal()}>{strings[lang].Rent2}</button><br></br>
      </div>
      <div className="book-content__box">
      <table
      ref={tableRef}
      style={{
      alignSelf: "center",
      textAlign: lang === "ar" ? "right" : "left",
      fontSize: "15px",
       }}
      >
        <thead>
                <tr>
                  <th>#</th>
                  <th>{strings[lang].Form2}</th>
                  <th>{strings[lang].Form29}</th>
                  <th>{strings[lang].Form3}</th>
                  <th>{strings[lang].Rent4}</th>
                  <th>{strings[lang].Rent5}</th>
                  <th>{strings[lang].Rent11}</th>
                  <th>{strings[lang].Truck6}</th>
                  <th>{strings[lang].Form51}</th>
                  {sessionStorage.getItem("usertype") === md5("admin") && (
                  <>
                  <th><b>{strings[lang].Form39}</b></th>
                  <th><b>{strings[lang].Form61}</b></th>
                  </>
                  )}
                  <th>
                  <i className="fa-solid fa-download" onClick={() => openDownloadModal()}></i>
                  </th>
                </tr></thead>
        {filteredData &&
          filteredData.slice(0, visibleRows).map(function (d, idx) {
            return (
              <tbody key={idx}>
                <tr key={idx}>
                  <td>{d.id}.</td>
                  <td>{d.name}</td>
                  <td>{d.license}</td>
                  <td>{d.mobile}</td>
                  <td>{d.car}</td>
                  <td style={{ color: d.plate === 1 ? "red" : null }}>{d.plate === 1 ? "?" : d.plate+""}</td>
                  <td>{(parseFloat(d.amount)+parseFloat(d.amount2)+parseFloat(d.amount3)+parseFloat(d.amount4)+parseFloat(d.vat)).toFixed(2)}</td>
                  <td>{d.company}</td>
                  <td>{d.ddate}</td>
                  {sessionStorage.getItem("usertype") === md5("admin") &&
                  <><td>{d.signature.toUpperCase()}</td>
                  <td>{d.signature2.toUpperCase()}</td></>}
                  <td><i className="fa-solid fa-download" onClick={() => generatePdf(d.id, d.name, d.license, d.mobile, d.car, d.plate, d.amount, d.amount2, d.amount3, d.amount4, d.vat, d.reason, d.reason2, d.reason3, d.reason4, d.company, d.ddate)}></i></td>
                  <td><i className="fa-solid fa-pen-to-square" onClick={() => openModal(d.id, d.name, d.license, d.mobile, d.car, d.plate, d.amount, d.amount2, d.amount3, d.amount4, d.vat, d.reason, d.reason2, d.reason3, d.reason4, d.company, d.ddate)}></i></td>
                </tr>
              </tbody>
            );
          })}
          {visibleRows < data.length && sessionStorage.getItem("usertype") === md5("admin") ? (
                        <tfoot><tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                        <i className="fa-solid fa-circle-chevron-down fa-lg" onClick={handleLoadMore}></i>
                        <i className="fa-solid fa-border-all fa-lg" style={{ marginLeft: "1rem" }} onClick={handleShowAll}></i>
                        {visibleRows > 10 ?<i className="fa-solid fa-circle-chevron-up fa-lg" style={{ marginLeft: "1rem" }} onClick={handleLoadLess}></i> : ""}
                        </td></tr></tfoot>)
                        : visibleRows < data.length && sessionStorage.getItem("usertype") === md5("team") ? (
                        <tfoot><tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                        <i className="fa-solid fa-circle-chevron-down fa-lg" onClick={handleLoadMore}></i>
                        <i className="fa-solid fa-border-all fa-lg" style={{ marginLeft: "1rem" }} onClick={handleShowAll}></i>
                        {visibleRows > 10 ?<i className="fa-solid fa-circle-chevron-up fa-lg" style={{ marginLeft: "1rem" }} onClick={handleLoadLess}></i> : ""}
                        </td></tr></tfoot>
                        ) : ""}
          </table>
      </div>

      {/* modal ------------------------------------ */}

      <div className={`booking-modal ${modal ? "active-modal" : ""}`} style={{ overflowY: "auto", maxHeight: "750px"}}>
        {/* title */}
        {/* car info */}
        <div className="booking-modal__car-info">
              <div className="team-container__box">
                <h2><i className="fa-solid fa-pen-to-square fa-2xl" onClick={() => closeModal()}></i></h2><br></br>
                <h3 style={{ textAlign: "left", marginTop: "1.5rem"}}>#{carId === "" ? "" : carId}</h3>
                <input type="date" placeholder={strings[lang].Form51} value={ddate} disabled />
                <select value={company} disabled onChange={handleCompany}>
                  {companies.map((data, idx) => (
              <option key={idx} value={data}> {data} </option>
              ))}
              </select>

                <span><input type="text" placeholder={strings[lang].Form2} value={name} onChange={(e) => setName(e.target.value)} />
                <input type="number" placeholder={strings[lang].Form29} value={license} style={{ marginLeft: "10px" }} onChange={(e) => setLicense(e.target.value)} /></span>

                <input type="number" placeholder={strings[lang].Reservation16} value={mobile} onChange={(e) => setMobile(e.target.value)} />
                <select value={carName} onChange={e => setCarName(e.target.value)}>
                <option>{strings[lang].Rent8}</option>
                {cars && cars.map(function(d, idx)
                { return (
                    <option value={d.name+" "+d.model} key={idx}>{d.name} {d.model}</option>
                )})}
                </select>
                <input type="number" placeholder={strings[lang].Rent9} value={carPlate} onChange={(e) => setCarPlate(e.target.value)} />

                <span><input type="text" placeholder={strings[lang].Rent10} value={reason} onChange={(e) => setReason(e.target.value)} />
                <input type="number" placeholder={strings[lang].Truck5} value={amount} disabled style={{ marginLeft: "10px" }} min={0} onChange={(e) => setAmount(e.target.value)} /></span>

                {reason2 === "" ? "" :
                <span>
                <input type="text" placeholder={strings[lang].Rent10} value={reason2} onChange={(e) => setReason2(e.target.value)} />
                <input type="number" placeholder={strings[lang].Truck5} value={amount2} disabled style={{ marginLeft: "10px" }} min={0} onChange={(e) => setAmount2(e.target.value)} />
                </span>}

                {reason3 === "" ? "" :
                <span>
                <input type="text" placeholder={strings[lang].Rent10} value={reason3} onChange={(e) => setReason3(e.target.value)} />
                <input type="number" placeholder={strings[lang].Truck5} value={amount3} disabled style={{ marginLeft: "10px" }} min={0} onChange={(e) => setAmount3(e.target.value)} />
                </span>}

                {reason4 === "" ? "" :
                <span>
                <input type="text" placeholder={strings[lang].Rent10} value={reason4} onChange={(e) => setReason4(e.target.value)} />
                <input type="number" placeholder={strings[lang].Truck5} value={amount4} disabled style={{ marginLeft: "10px" }} min={0} onChange={(e) => setAmount4(e.target.value)} />
                </span>}

                <input type="number" placeholder={strings[lang].Reservation20} min={0} disabled value={vat} />
                <button type="submit" onClick={() => updateRent()}>
                {strings[lang].Vehicles38}
                </button> 
              </div>
        </div>
      </div>

      {/* modal ------------------------------------ */}

      <div className={`booking-modal ${addmodal ? "active-modal" : ""}`} style={{ overflowY: "auto", maxHeight: "750px"}}>
        {/* title */}
        {/* car info */}
        <div className="booking-modal__car-info">
              <div className="team-container__box">
                <h2><i className="fa-regular fa-address-book fa-2xl" onClick={() => closeAddModal()}></i></h2><br></br>
                <h3 style={{ textAlign: "left", marginTop: "1.5rem"}}>#{last}</h3>
                <input type="date" placeholder={strings[lang].Form51} value={ddate} onChange={(e) => setDdate(e.target.value)} />

                <select disabled={disableComp} id="myCompany" onChange={handleCompany}>
                <option value="" >{strings[lang].Truck8}</option>
                {companies.map((data, idx) => (
                <option key={idx} value={data}> {data} </option>
                ))}
                </select>
                <span><input type="text" placeholder={strings[lang].Form2} value={name} onChange={(e) => setName(e.target.value)} />
                <input type="number" placeholder={strings[lang].Form29} value={license} style={{ marginLeft: "70px" }} onChange={(e) => setLicense(e.target.value)} /></span>

                <input type="number" placeholder={strings[lang].Reservation16} value={mobile} onChange={(e) => setMobile(e.target.value)} />

                <select value={carName} onChange={e => setCarName(e.target.value)}>
                <option>{strings[lang].Rent8}</option>
                {cars && cars.map(function(d, idx)
                { return (
                    <option value={d.name+" "+d.model} key={idx}>{d.name} {d.model}</option>
                )})}
                </select>
                <input type="number" placeholder={strings[lang].Rent9} value={carPlate} onChange={(e) => setCarPlate(e.target.value)} />
                <span>
                <input type="text" placeholder={strings[lang].Rent10} value={reason} onChange={(e) => setReason(e.target.value)} />
                <input type="number" placeholder={strings[lang].Truck5} min={0} style={{ marginLeft: "10px" }} value={amount} onChange={(e) => setAmount(e.target.value)} />
                <button type="text" placeholder={strings[lang].Rent10} style={{ marginLeft: "10px", width: "50px", borderRadius: "50px" }} onClick={handleClick}>+</button>
                </span>
                {newLine !== 1 && newLine !== 2 && newLine !== 3 ? "" :
                <span>
                <input type="text" placeholder={strings[lang].Rent10} value={reason2} onChange={(e) => setReason2(e.target.value)} />
                <input type="number" placeholder={strings[lang].Truck5} min={0} style={{ marginLeft: "10px", marginRight: "60px" }} value={amount2} onChange={(e) => setAmount2(e.target.value)} />
                </span>}
                {newLine !== 2 && newLine !== 3 ? "" :
                <span>
                <input type="text" placeholder={strings[lang].Rent10} value={reason3} onChange={(e) => setReason3(e.target.value)} />
                <input type="number" placeholder={strings[lang].Truck5} min={0} style={{ marginLeft: "10px", marginRight: "60px" }} value={amount3} onChange={(e) => setAmount3(e.target.value)} />
                </span>}
                {newLine !== 3 ? "" :
                <span>
                <input type="text" placeholder={strings[lang].Rent10} value={reason4} onChange={(e) => setReason4(e.target.value)} />
                <input type="number" placeholder={strings[lang].Truck5} min={0} style={{ marginLeft: "10px", marginRight: "60px" }} value={amount4} onChange={(e) => setAmount4(e.target.value)} />
                </span>}
                <input type="number" placeholder={strings[lang].Reservation20} min={0} value={vat} onChange={(e) => setVat(e.target.value)} />
                <h2 style={{ marginBottom: "10px", marginTop: "10px"}}>{strings[lang].Reservation9}: {amount === "" ? "0" : (parseFloat(amount)+parseFloat(amount2)+parseFloat(amount3)+parseFloat(amount4)+parseFloat(vat)).toFixed(2)}</h2>
                <button type="submit" onClick={() => addDamage()}>
                {strings[lang].Vehicles37}
                </button> 
              </div>
        </div>
      </div>

      {/* ------------------------------------------- Download modal ----------------------------------- */}
                
      <div className={`booking-modal ${dldmodal ? "active-modal" : ""}`}>
        <div className="booking-modal__car-info">
          <div className="team-container__box">
            <h2><i className="fa-solid fa-receipt fa-2xl" onClick={() => openDownloadModal()}></i></h2><br></br>
              <select disabled={disableComp} id="myCompany1" onChange={handleCompany}>
                <option value="" >{strings[lang].Truck8}</option>
                {companies.map((data, idx) => (
                <option key={idx} value={data}> {data} </option>
                ))}
              </select>
              <span>
              <input type="date" disabled={company === "" ? true : false} placeholder={strings[lang].Rent6} value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              <input type="date" disabled={startDate === "" ? true : false} placeholder={strings[lang].Rent6} value={endDate} style={{ marginLeft: "5px" }} onChange={(e) => FormDld(e.target.value)} />
              </span>
              <button type="submit" disabled={endDate === "" ? true : false} style={{ backgroundColor: endDate === "" ? "grey" : "" }} onClick={() => getInvoice()} >
              {strings[lang].Form55} INVOICE
              </button>
              <button type="submit" disabled={endDate === "" ? true : false} style={{ backgroundColor: endDate === "" ? "grey" : "", marginTop: "15px" }} onClick={() => openDownloadModal()}><DownloadTableExcel
               filename={company+"_"+formattedDate}
               sheet="Damages"
               currentTableRef={tableRef.current}
              >{strings[lang].Form55} EXCEL</DownloadTableExcel></button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Damages;
